import React from "react";

import i18next from "external/i18n";

export const CustomerSignOffContent = () => (
  <>
    <p>{i18next.t("help.claim.content.customerSignOff.content.paragraph")}</p>
  </>
);
